import { ApiService } from '~/services/api/api'

export interface LtiSyncGradeResponse {
  synced: boolean
  reason?: string
}

export interface LtiSyncAllGradesResponse {
  total: number
  synced: number
  failed: number
  skipped: number
  details?: Array<{ testAttemptId: string; synced: boolean; reason?: string }>
}

export class LtiGradeSyncService {
  private readonly apiService = new ApiService()

  async postSyncGrade(testAttemptId: string) {
    const response = await this.apiService.post<LtiSyncGradeResponse>(
      `/integrations/lti/test-attempts/${testAttemptId}/sync-grade`,
      undefined,
    )
    return response
  }

  async postSyncGradesByTestId(testId: string) {
    const response = await this.apiService.post<LtiSyncAllGradesResponse>(
      `/integrations/lti/tests/${testId}/sync-grades`,
      undefined,
    )
    return response
  }

  async getSyncGradesStatusByTestId(testId: string) {
    const response = await this.apiService.get<{ hasDeepLinks: boolean }>(
      `/integrations/lti/tests/${testId}/grade-sync-status`,
    )
    return response
  }
}
